const UserMailing = {
  computed: {
    ...Vuex.mapState(['user', 'profile']),
  },
  methods: {
    updateProfile(profile) {
      axios
        .post('/directorio/datos/', { profile })
        .then((result) => {
          customAlert('', 'Se han guardado tus preferencias');
        })
        .catch((err) => {
          customAlert(
            'Ha ocurrido un error',
            'No hemos podido actualizar tus preferencias, por favor inténtalo más tarde.',
          );
          console.error('Mailing KO!', err.response);
        });
    },
    updateMailing(mailing) {
      axios
        .post('/usuarios/mailing/', { mailing })
        .then((result) => {
          customAlert('', 'Se han guardado tus preferencias');
        })
        .catch((err) => {
          customAlert(
            'Ha ocurrido un error',
            'No hemos podido actualizar tus preferencias, por favor inténtalo más tarde.',
          );
          console.error('Mailing KO!', err.response);
        });
    },
  },
  template: `
    <div class="user-mailing-form" v-if="user.mailing">
      <div v-if="profile.type">
        <label>
          <input
            type="checkbox"
            class="uk-checkbox"
            v-model="profile.notify"
            @change="updateProfile(profile)"
          />
          <template v-if="profile.type === 'P'">
            Recibir notificaciones de nuevas ofertas de empleo relacionadas con mi perfil.
          </template>
          <template v-if="profile.type === 'E'">
            Recibir notificaciones de presupuestos y ofertas de trabajo relacionadas con mi perfil.
          </template>
        </label>
      </div>
      <div class="uk-margin-small-top">
        <label>
          <input class="uk-checkbox" type="checkbox" v-model="user.mailing.marketing" @change="updateMailing(user.mailing)">
          Quiero recibir correos electrónicos ocasionales con información acerca de como utilizar el sitio web y mejorar
          mi cuenta.
        </label>
      </div>
      <div class="uk-margin-small-top">
        <label>
          <input class="uk-checkbox" type="checkbox" v-model="user.mailing.bookmarks" @change="updateMailing(user.mailing)">
          Quiero recibir correos electrónicos con las ofertas de trabajo que he guardado.
        </label>
      </div>
    </div>
  `,
};
